export function getIdBasedGeneralProperties(componentType, newProperties) {
    switch (componentType) {
        case "Kanban":
            return {
                primaryGroupByAttributeId: newProperties.primaryGroupBy ? newProperties.primaryGroupBy._id : null,
                rowColumnGroupByAttributeId: newProperties.rowGroupBy ? newProperties.rowGroupBy._id : null,
                sortByAttributeId: newProperties.sortBy ? newProperties.sortBy.id : null,
                editPageId: newProperties.editPage ? newProperties.editPage._id : null,
                coverImageAttribute: newProperties.coverImageAttribute ? newProperties.coverImageAttribute._id : ""
            }
        case "Cards":
            return {
                coverImageAttribute: newProperties.coverImageAttribute ? newProperties.coverImageAttribute._id : ""
            }
        case "SpecificHeading":
            return {
                firstAttributeId: newProperties.firstAttribute ? newProperties.firstAttribute._id : null,
                secondAttributeId: newProperties.secondAttribute ? newProperties.secondAttribute._id : null,
            }
        case "GroupHeading":
            return {
                referenceAttributeId: newProperties.referenceLabelAttribute ? newProperties.referenceLabelAttribute._id : null,
            }
        case "Progress Bar":
            return {
                statusAttributeId: newProperties.statusAttribute ? newProperties.statusAttribute._id : null,
            }
        case "Calendar": {
            return {
                startDateAttributeId: newProperties.startDateAttribute ? newProperties.startDateAttribute._id : null,
                endDateAttributeId: newProperties.endDateAttribute ? newProperties.endDateAttribute._id : null,
                addPageId: newProperties.addPage ? newProperties.addPage._id : null,
                editPageId: newProperties.editPage ? newProperties.editPage._id : null,
                flyoverLabelAttributeId: newProperties.flyoverLabelAttribute ? newProperties.flyoverLabelAttribute._id : null,
                flyoverLabel: newProperties.useAttributeInFlyoverLabel ? "" : newProperties.flyoverLabel,
            }
        }
        case "Gantt Chart":
            return {
                startDateAttributeId: newProperties.startDateAttribute ? newProperties.startDateAttribute._id : "",
                endDateAttributeId: newProperties.endDateAttribute ? newProperties.endDateAttribute._id : "",
                dependentAttributeId: newProperties.dependentAttribute ? newProperties.dependentAttribute._id : "",
                workAttributeId: newProperties.workAttribute ? newProperties.workAttribute._id : "",
                resourceAttributeId: newProperties.resourceAttribute ? newProperties.resourceAttribute._id : "",
                durationAttributeId: newProperties.durationAttribute ? newProperties.durationAttribute._id : "",
                progressAttributeId: newProperties.progressAttribute ? newProperties.progressAttribute._id : "",
                editPageId: newProperties.editPage ? newProperties.editPage._id : "",
                addPageId: newProperties.addPage ? newProperties.addPage._id : "",
                sortByAttributeId: newProperties.sortByAttribute ? newProperties.sortByAttribute._id : "",
                gridLines: newProperties.gridLines ? newProperties.gridLines.value : "Both",
                ganttChartView: newProperties.ganttChartView ? newProperties.ganttChartView.value : "Task View",
                topUnit: newProperties.topUnit ? newProperties.topUnit.value : "Week",
                bottomUnit: newProperties.bottomUnit ? newProperties.bottomUnit.value : "Day",
                sortOrder: newProperties.sortOrder ? newProperties.sortOrder.value : "Descending",
            }
        default:
            return {}
    }
}

export function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}